import { NgClass } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from '../../services/layout.service';
import { MenuComponent } from '../menu/menu.component';

@Component({
  selector: 'igx-sidebar',
  imports: [MenuComponent, NgClass],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  public menu = input.required<MenuItem[]>();
  private readonly _layoutService = inject(LayoutService);

  public get sidebarClass() {
    return {
      'sidebar--overlay': this._layoutService.layoutConfig().menuMode === 'overlay',
      'sidebar--static': this._layoutService.layoutConfig().menuMode === 'static',
      'sidebar--static-inactive':
        this._layoutService.layoutState().staticMenuDesktopInactive &&
        this._layoutService.layoutConfig().menuMode === 'static',
      'sidebar--overlay-active': this._layoutService.layoutState().overlayMenuActive,
      'sidebar--mobile-active': this._layoutService.layoutState().staticMenuMobileActive,
    };
  }
}
